export enum EModalComponents {
  DOWNLOAD_MOBILE_APP_DIALOG = 'DOWNLOAD_MOBILE_APP_DIALOG'
}
